import { inject } from '@angular/core';
import { type CanMatchFn } from '@angular/router';

import { AuthService } from './auth.service';

/**
Builds a `CanMatchFn` that additionally requires at least one of the given
realm roles, on top of plain authentication.

An authenticated-but-under-permissioned user is blocked rather than sent
through another login redirect (re-authenticating would not grant a role
it doesn't have) — the route simply fails to match, falling through to the
app's wildcard route.
@param requiredRoles - Realm role names; the user needs at least one.
@returns A `CanMatchFn` blocking the route match for unauthenticated or under-permissioned users.
*/
export function roleGuard(requiredRoles: readonly string[]): CanMatchFn {
  return () => {
    const authService = inject(AuthService);

    if (!authService.isAuthenticated()) {
      void authService.login();

      return false;
    }

    if (authService.hasAnyRole(requiredRoles)) {
      return true;
    }

    console.warn(`[roleGuard] Blocked: user lacks any of [${requiredRoles.join(', ')}].`);

    return false;
  };
}
